// src/components/GlobalModal.tsx
import React, { useEffect, useState } from "react";
import { useEvents } from "context/EventsContext";
import "react-calendar/dist/Calendar.css";

// NUEVO: importar axiosInstance y el modal de aviso
import axiosInstance from "utils/axiosInstance";
import AvisoModal from "components/AvisoModal";
import Modal from "components/Modal";
import { Button, SelectorFecha } from "components/ui";

export default function GlobalModal() {
  const {
    isModalOpen,
    closeModal,
    nuevoEvento,
    setNuevoEvento,
    tipo,
    setTipo,
    editEvento,
    crearEvento,
    actualizarEvento,
  } = useEvents();

  // For controlling the <Calendar> popup

  // --- NUEVO: estado para el aviso global ---
const [aviso, setAviso] = useState<{ texto: string } | null>(null);
const [showAviso, setShowAviso] = useState(false);


      // --- NUEVO: fetch del aviso activo desde el backend ---
      useEffect(() => {
        let mounted = true;

        const fetchAviso = async () => {
          try {
            const { data } = await axiosInstance.get("/aviso");
            if (!mounted) return;

            if (!data) {
              setAviso(null);
              setShowAviso(false);
              return;
            }

            setAviso({ texto: data.texto });
            setShowAviso(true);
          } catch (err) {
            console.error("Error fetching aviso:", err);
          }
        };

        fetchAviso();

        return () => {
          mounted = false;
        };
      }, []);

  // Are we editing or creating a new event?
  const isEdit = !!editEvento;

  // Handler for "Save" button
  const onSave = () => {
    if (isEdit) actualizarEvento();
    else crearEvento();
  };

    const handleCloseAviso = () => {
      setShowAviso(false);
    };
    
  return (
    <>
      {/* Aviso global (se monta independientemente del modal de eventos) */}
      {showAviso && aviso && (
        <AvisoModal texto={aviso.texto} onClose={handleCloseAviso} />
      )}

      {/* Modal de eventos original — ahora sobre el <Modal /> compartido, así
          hereda scrim, animación, cierre con Esc y bloqueo de scroll */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="mb-5">
          <h3 className="text-[19px] font-semibold text-gray-900 dark:text-white">
            {isEdit ? "Editar evento" : "Crear evento"}
          </h3>
          <p className="mt-1 text-sm leading-relaxed text-gray-700 dark:text-gray-400">
            {isEdit
              ? "Modificá la fecha o el tipo del evento seleccionado."
              : "Elegí la fecha y el tipo del nuevo evento."}
          </p>
        </div>

        {/* FECHA */}
        <div className="mb-4 w-full">
          <SelectorFecha value={nuevoEvento} onChange={setNuevoEvento} />
        </div>

        {/* SELECT PARA EL TIPO DE EVENTO */}
        <div className="relative w-full">
          <label className="mb-1.5 block text-[13px] font-medium text-gray-900 dark:text-gray-200">
            Tipo de evento
          </label>
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            className="block h-10 w-full cursor-pointer appearance-none rounded-field border border-gray-200 bg-white px-3 pr-9 text-sm font-medium text-gray-900 transition-colors duration-150 hover:border-gray-300 dark:border-white/10 dark:bg-navy-900 dark:text-white dark:hover:border-white/20"
          >
            <option value="Fútbol">Fútbol</option>
            <option value="Peña">Peña</option>
          </select>
          {/* Icono flecha personalizado */}
          <div className="pointer-events-none absolute right-3 top-[34px] text-gray-600">
            <svg
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.614l3.71-3.384a.75.75 0 011.04 1.08l-4.25 3.88a.75.75 0 01-1.04 0l-4.25-3.88a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* BOTONES DE ACCION */}
        <div className="mt-6 flex flex-col-reverse gap-2 border-t border-gray-200/80 pt-5 dark:border-white/10 sm:flex-row sm:justify-end">
          <Button variant="secondary" onClick={closeModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={onSave}>
            {isEdit ? "Guardar cambios" : "Crear"}
          </Button>
        </div>
      </Modal>
    </>
  );
}
